













import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class extends Vue {

  @Prop({
    default: ''
  })
  label!: string

  @Prop({
    default: 1
  })
  span!: number

  @Prop({
    default: false
  })
  compact!: boolean
}
